import styled from 'styled-components'

interface ProfileConfigButtonProps {
  selected?: boolean
}

export const Container = styled.div`
  width: 100vw;
  background: ${({ theme }) => `rgb(${theme.background.high})`};
  padding: 1rem;
  display: flex;
  flex: 1;
  justify-content: space-between;
  margin-top: 70px;
  overflow-x: auto;

  ::-webkit-scrollbar {
    height: 5px;
  }
  ::-webkit-scrollbar-track {
    background: #fff;
  }
  ::-webkit-scrollbar-thumb {
    background: #aaa;
    border-radius: 50px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #333;
  }

  @media only screen and (min-width: 900px) {
    position: fixed;
    left: 0;
    max-width: 300px;
    height: calc(100vh - 60px);
    margin-top: -10px;
    flex-direction: column;
    justify-content: flex-start;
  }
`

export const ProfileConfigButton = styled.button<ProfileConfigButtonProps>`
  border: none;
  border-radius: 8px;
  background: ${(props) => (props.selected ? `rgba(${props.theme.primary[100]})` : 'none')};

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 1rem;
  line-height: 1.1875rem;
  font-weight: 500;

  color: ${(props) =>
    props.selected ? `rgb(${props.theme.primary[600]})` : `rgb(${props.theme.primary[700]})`};

  padding: 0.9rem;

  svg {
    margin-right: 0.5rem;
  }

  @media only screen and (min-width: 900px) {
    margin: 0.8rem auto;
  }
`

export const SignOutButton = styled(ProfileConfigButton)`
  svg {
    transform: scaleX(-1);
  }
  @media only screen and (max-width: 900px) {
    display: none;
  }
`

export const BackButton = styled.button`
  margin: 1rem auto 3rem 0;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 1rem;
  line-height: 1.1875rem;
  font-weight: 400;

  border: none;
  background: none;
  color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

  svg {
    margin-right: 0.5rem;
  }

  @media only screen and (max-width: 900px) {
    display: none;
  }
`
